import { ensureSingleTagExists } from '../../helpers';
import { ITagDefinition, TTag } from '../../index';
import { IJsonQueryNewbuildingHouse } from '../../../../../repositories/common/json_query';

const INewbuildingHouseTagType = 'newbuilding-house';

export interface INewbuildingHouseTag {
  type: 'newbuilding-house';
  value: string;
  text: string;
}

const isNewbuildingHouseTag = (tag: TTag): tag is INewbuildingHouseTag => tag.type === INewbuildingHouseTagType;

export const geoNewbuildingHouseTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery, tagsData) => {
    const values =
      jsonQuery.geo &&
      (jsonQuery.geo.value.filter(geo => geo.type === 'nb_house_key') as IJsonQueryNewbuildingHouse[]).map(
        geo => geo.key,
      );

    let nextTags = tags.filter(
      tag => tag.type !== INewbuildingHouseTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce((result, value) => {
        const tagData = tagsData.newbuildingHouses[value];

        return ensureSingleTagExists(
          result,
          (tag: TTag): tag is INewbuildingHouseTag => isNewbuildingHouseTag(tag) && tag.value === value,
          previousTag => ({
            type: INewbuildingHouseTagType,
            value,
            text: tagData || 'Неизвестный корпус ЖК',
          }),
        );
      }, nextTags);
    }

    return nextTags;
  },
};
